import React from 'react';
import styled from 'styled-components';
import { Carousel, H2, spacingHelper, Stack, typographyHelper } from '@construct-kit/core';
import { layout } from '../../../../styles/_variables';
import ExploreOthersItem from './ExploreOthersItem';
import { DEFAULT_ITEMS } from '../constants/exploreOthers';

const Container = styled(Stack)`
  margin-top: 2.25rem;
  overflow: hidden;
  ${({ theme }) => theme.layoutBreakpoints.large} {
    width: 100%;
    max-width: ${layout.maxWidthDesktopWide};
    margin: 3rem auto 0 auto;
  }
`;

const Title = styled(H2)`
  margin: 0 0 ${spacingHelper('medium')};
  ${typographyHelper('title02')};

  ${({ theme }) => theme.layoutBreakpoints.large} {
    ${typographyHelper('title01')};
  }
`;

const ExploreOthers: React.FunctionComponent = () => (
  <Container inset="0 medium medium medium" gap="medium">
    <Title>Explore all things commercial property</Title>
    <Carousel insideGap="medium" outsideGap="0" showScrollButtons="auto">
      {DEFAULT_ITEMS.map((exploreOthersObject) => (
        <ExploreOthersItem key={exploreOthersObject.id} exploreOthersObject={exploreOthersObject} />
      ))}
    </Carousel>
  </Container>
);

export default ExploreOthers;
